var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.88525 7.38166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c3c3b;}.cls-2{fill:#078136;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trainentry_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.88525.71V0c-1.72,0-3.11.2-3.11,1.56V5.25a1.35932,1.35932,0,0,0,1.36,1.35l-.58.59v.19h2.33V3.5h-2.12a.21359.21359,0,0,1-.21-.22V1.56C8.55523.99,9.72527.71,10.88525.71Zm-1.75,3.95a.585.585,0,1,1-.58.59A.58266.58266,0,0,1,9.13525,4.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.972 4.808 4.972 4.208 4.117 5.066 4.972 5.923 4.972 5.323 6.862 5.323 6.862 4.808 4.972 4.808"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.008 6.267 4.117 6.267 4.117 6.781 6.008 6.781 6.008 7.382 6.862 6.524 6.008 5.666 6.008 6.267"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.57342,
    cy: 0.69078,
    r: 0.68624
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.28671,2.54364l-.94359,4.838h.72056l.60046-2.745.73771.68625V7.38166H3.0881V4.79109l-.7034-.7034.20587-1.02937a2.39424,2.39424,0,0,0,1.87.89212V3.2642A1.75908,1.75908,0,0,1,2.968,2.42355l-.326-.549a.66923.66923,0,0,0-.58331-.326.68842.68842,0,0,0-.25734.05146L0,2.33777V3.95044H.68624V2.801l.60047-.25734Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainentry);
export default __webpack_public_path__ + "static/media/trainentry.db62fdd0b30dfc815b0658d073eec14c.svg";
export { ForwardRef as ReactComponent };